import {
  useState,
  useContext,
  createContext,
  useEffect,
  useReducer,
} from "react";
import { useAuth } from "./AuthProvider";
import { GetPackageList } from "../services/GetPackageListService";
import tourlistReducer from "./TourListReducer";
import { useUser } from "./UserProvider";

const TourListPrividerContext = createContext();
const TourListProviderContextDispatcher = createContext();

const initialState = {
  allTourLists: [],
  tourlists: [],
  filterdStateTourList: [],
  filterdTypeTourList: [],
  sortedTypeTourList: [],
};

function TourListProvider({ children }) {
  //const [tourlists, setTourlists] = useState([]);
  const [tourlistsContext, dispatch] = useReducer(
    tourlistReducer,
    initialState
  );
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(true);
  const [tourState, setTourState] = useState(0);
  const { stateAuth } = useAuth();
  const user = useUser();
  const floatingCompanyId = user.FloatingCompanyId;

  return (
    <TourListPrividerContext.Provider
      value={{
        tourlistsContext,
        isLoading,
        error,
        tourState,
      }}
    >
      <TourListProviderContextDispatcher.Provider
        value={{ dispatch, setTourState, setIsLoading, setError }}
      >
        {children}
      </TourListProviderContextDispatcher.Provider>
    </TourListPrividerContext.Provider>
  );
}


export default TourListProvider;

export const useTourList = () => useContext(TourListPrividerContext);
export const useTourListActions = () =>
  useContext(TourListProviderContextDispatcher);
